/* tslint:disable */
import { Translation } from './translation';

/**
 */
export class LoadTransLang {
    translation?: Translation[];
    referenceLangs?: Translation[];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/load-trans-lang.ts